var exports = {
  "q": "x7f9a0e16--7602b5--footer",
};

module.exports = exports;
